import { FilterCompanyCustomersWebPage, getCompanyCustomersWebPage } from 'commons/service/bank/companyDetails'
import { CompanyCustomersWebPage } from 'commons/types/DTO/bank/companyDetails/customer'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyCustomersWebPage: WriteHook<FilterCompanyCustomersWebPage, CompanyCustomersWebPage> = (
  opts
) => useMutationManager(getCompanyCustomersWebPage, opts)
